import { getTrackingService } from './TrackingServiceInstance';

export const updateVisitorProperties = (
    obj: { [key: string]: unknown },
    options?: { suppressConversion?: boolean },
) => getTrackingService().getSession().updateVisitorProperties(obj, options);

export const triggerDeferredConversion = () =>
    getTrackingService().getSession().triggerDeferredConversion();

export const getVisitorProperties = () => getTrackingService().getSession().getVisitorProperties();
